import { createWalletClient, createPublicClient, custom, http, defineChain, getAddress } from "viem";

export function buildChain(cfg) {
  return defineChain({
    id: cfg.chain_id,
    name: "Robinhood Chain",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: { default: { http: [cfg.rpc_url] } },
    blockExplorers: { default: { name: "Blockscout", url: cfg.explorer_url } },
  });
}

export async function connectInjected() {
  if (!window.ethereum) throw new Error("No wallet detected. Install MetaMask or a compatible wallet.");
  const [addr] = await window.ethereum.request({ method: "eth_requestAccounts" });
  return getAddress(addr);
}

export function getWalletClient(cfg) {
  if (!window.ethereum) throw new Error("No wallet detected");
  return createWalletClient({ chain: buildChain(cfg), transport: custom(window.ethereum) });
}

export function getPublicClient(cfg) {
  return createPublicClient({ chain: buildChain(cfg), transport: http(cfg.rpc_url) });
}

export async function ensureChain(cfg) {
  const client = getWalletClient(cfg);
  try {
    await client.switchChain({ id: cfg.chain_id });
  } catch (e) {
    await client.addChain({ chain: buildChain(cfg) });
    await client.switchChain({ id: cfg.chain_id });
  }
  return client;
}

export const DISTRIBUTOR_ABI = [
  { name: "claim", type: "function", stateMutability: "nonpayable", inputs: [{ name: "cumulativeAmount", type: "uint256" }, { name: "proof", type: "bytes32[]" }], outputs: [] },
  { name: "claimed", type: "function", stateMutability: "view", inputs: [{ name: "", type: "address" }], outputs: [{ type: "uint256" }] },
];
